import React from "react";
import {
  useRouteError,
  isRouteErrorResponse,
  useNavigate,
} from "react-router-dom";
import { Button } from "@mui/material";
import ErrorDisplay from "./ErrorDisplay";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

const RouteError = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  console.log(error);

  let message = "Something went wrong.";
  let details = "An unexpected error occurred.";
  let icon = <SentimentVeryDissatisfiedIcon fontSize="inherit" />;

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      message = "Page Not Found";
      details = "The page you are looking for does not exist.";
    } else {
      message = `Error ${error.status}`;
      details = error.statusText || error.data?.message || "Unknown error";
    }
  } else if (error instanceof Error) {
    details = error.message;
  }

  return (
    <ErrorDisplay
      message={message}
      details={details}
      icon={icon}
      actions={
        <Button variant="contained" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      }
    />
  );
};

export default RouteError;
